import React, { useState } from "react";

import "./Contact.css";

const Contact = () => {

  const [formData, setFormData] = useState({

    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: ""

  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {

    setFormData({

      ...formData,

      [e.target.name]: e.target.value

    });

  };

const handleSubmit = async (e) => {

  e.preventDefault();

  try {

    const response = await fetch(

      "https://fidinventures.in/api/send_mail.php",

      {

        method: "POST",

        headers: {

          "Content-Type": "application/json",

        },

        body: JSON.stringify(formData),

      }

    );

    const data = await response.json();

    if (data.success) {

      setSubmitted(true);

      setTimeout(() => {

        setSubmitted(false);

      }, 3000);

      setFormData({

        name: "",
        email: "",
        mobile: "",
        subject: "",
        message: ""

      });

    } else {

      alert(data.message);

    }

  }

  catch (error) {

    console.log(error);

    alert("Server Error");

  }

};

  return (



      <div className="contact-page">

        {/* HERO SECTION */}

        <section className="contact-hero">

          <div className="contact-overlay"></div>

          <div className="contact-hero-content">

            <h1>
              Let's Connect
            </h1>

            <p>
              Have a project idea, business query,
              or collaboration in mind?
              We are always ready to help you.
            </p>

          </div>

        </section>

        {/* CONTACT SECTION */}

        <section className="contact-section">

          <div className="contact-wrapper">

            {/* LEFT SIDE */}

            <div className="contact-info-section">

              <span className="contact-tag">
                CONTACT US
              </span>

              <h2>
                Build Your Future
                With FIDIN Ventures
              </h2>

              <p>
                Whether you have a question,
                an idea, or a project requirement,
                our team is here to guide you
                through every step.
              </p>

              <div className="contact-info-grid">

                <div className="info-card">

                  <div className="info-icon">
                    📧
                  </div>

                  <div>

                    <h4>Email</h4>

                    <p>
                      info@fidinventures.com
                    </p>

                  </div>

                </div>

                <div className="info-card">

                  <div className="info-icon">
                    📞
                  </div>

                  <div>

                    <h4>Phone</h4>

                    <p>
                      +91 9876543210
                    </p>

                  </div>

                </div>

                <div className="info-card">

                  <div className="info-icon">
                    📍
                  </div>

                  <div>

                    <h4>Location</h4>

                    <p>
                      India
                    </p>

                  </div>

                </div>

              </div>

            </div>

            {/* RIGHT SIDE FORM */}

            <div className="contact-form-section">

              <form
                className="contact-form"
                onSubmit={handleSubmit}
              >

                <div className="form-row">

                  <div className="input-box">

                    <label>
                      Full Name
                    </label>

                    <input
                      type="text"
                      name="name"
                      placeholder="Enter your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />

                  </div>

                  <div className="input-box">

                    <label>
                      Email Address
                    </label>

                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />

                  </div>

                </div>

                <div className="form-row">

                  <div className="input-box">

                    <label>
                      Mobile Number
                    </label>

                    <input
                      type="tel"
                      name="mobile"
                      placeholder="Enter mobile number"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                    />

                  </div>

                  <div className="input-box">

                    <label>
                      Subject
                    </label>

                    <input
                      type="text"
                      name="subject"
                      placeholder="Enter subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />

                  </div>

                </div>

                <div className="input-box">

                  <label>
                    Your Message
                  </label>

                  <textarea
                    name="message"
                    rows="7"
                    placeholder="Write your message here..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>

                </div>

                <button
                  type="submit"
                  className="send-btn"
                >
                  Send Message
                </button>

                {submitted && (

                  <div className="success-message">

                    Message Sent Successfully!

                  </div>

                )}

              </form>

            </div>

          </div>

        </section>

      </div>


  );

};

export default Contact;